import * as yup from 'yup';
import { EstadoPyLCodigoEnum } from '../interfaces/erp/administration/estados-pyl.interface';
import { PaymentMethodEnum } from '../interfaces/erp/system-settings/payment-methods/payment-methods.interface';

import { validateEcuadorianCI } from './validationCI';

////* Auth
export const emailYupValidation = yup
  .string()
  .matches(
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    'Correo electrónico inválido'
  )
  .required('Correo electrónico es Requerido')
  .min(5, 'Min 5 characteres')
  .max(48, 'Max 48 characteres');

export const passwordYupValidation = yup
  .string()
  .required('La contraseña es requerida')
  .min(5, 'La contraseña debe tener al menos 5 caracteres')
  .max(33, 'La contraseña debe tener como máximo 33 caracteres');

export const SecurePasswordYupValidation = yup
  .string()
  .required('La contraseña es requerida')
  .min(5, 'La contraseña debe tener al menos 5 caracteres')
  .max(33, 'La contraseña debe tener como máximo 33 caracteres')
  .matches(
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+=[\]{};':"\\|,.<>?/-]).{8,}$/,
    'La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula, un número y un carácter especial.'
  )

export const codeModelYupValidation = yup
  .string()
  .required('El código es requerido')
  .min(3, 'Min 3 characteres')
  .max(50, 'La longitud máxima es 50 caracteres');

export const registerFormSchema = yup.object({
  email: emailYupValidation,
  password: passwordYupValidation,
  last_name: yup
    .string()
    .required('Name is requiered')
    .min(2, 'Min 2 characteres')
    .max(30, 'Max 12 characteres'),
  name: yup
    .string()
    .required('Name is requiered')
    .min(2, 'Min 2 characteres')
    .max(30, 'Max 12 characteres'),
  confirmPassword: yup
    .string()
    .required('Confirm password is requiered')
    .oneOf([yup.ref('password')], 'Passwords must match'),
});

export const usernameLoginSchema = yup.object({
  username: yup.string().required('El username es Requerido'),
  password: passwordYupValidation,
  nombre_comercial: yup.string().required('La empresa es requerida'),
});

export const changePasswordSchema = yup.object({
  // username_or_email: yup.string().required('El username es Requerido'),
  old_password: passwordYupValidation,
  password: SecurePasswordYupValidation,
});

export const emailLoginSchema = yup.object({
  // username_or_email: emailYupValidation,
  username: emailYupValidation,
  password: passwordYupValidation,
  nombre_comercial: yup.string().required('La empresa es requerida'),
});

///* General
const descriptionYupValidation = yup
  .string()
  .optional()
  .max(100, 'La longitud máxima es 100 caracteres');

const fieldNameYupValidation = yup
  .string()
  .test('trim', 'El nombre es Requerido', value => {
    const trimmedValue = value ? value.trim() : '';
    return trimmedValue.length > 0;
  })
  .required('El nombre es Requerido')
  .max(50, 'La longitud máxima es 50 caracteres')
  .matches(/^[^\s].*$/, 'No debe empezar con espacios');

export const fieldTextYup = yup
  .string()
  .test('trim', 'El nombre es Requerido', value => {
    const trimmedValue = value ? value.trim() : '';
    return trimmedValue.length > 0;
  })
  .required('El nombre es Requerido')
  .max(50, 'La longitud máxima es 50 caracteres')
  .matches(/^[^\s].*$/, 'No debe empezar con espacios')
  .matches(/^[A-Za-zñÑ\s]+$/, 'Solo se admiten caracteres de la A a la Z');

export const fieldStateYupValidation = yup
  .boolean()
  .typeError('El estado es Requerido')
  .required('El estado es Requerido');

export const fieldPoolIpV4YupValidation = yup
  .string()
  .matches(
    /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/,
    'Direccion IPv4 inválida'
  )
  .required('El pool de IP es Requerido')
  .max(50, 'El pool de IP debe tener como máximo 50 caracteres');

const ipv4ToInt = (ip: string): number | null => {
  const parts = ip.split('.');
  if (parts.length !== 4) return null;
  const nums = parts.map(p => Number(p));
  if (nums.some(n => Number.isNaN(n) || n < 0 || n > 255)) return null;
  return (
    ((nums[0] << 24) >>> 0) |
    ((nums[1] << 16) >>> 0) |
    ((nums[2] << 8) >>> 0) |
    (nums[3] >>> 0)
  ) >>> 0;
};

const cidrToMaskInt = (cidr: number): number | null => {
  if (!Number.isFinite(cidr) || cidr < 0 || cidr > 32) return null;
  if (cidr === 0) return 0;
  return (0xffffffff << (32 - cidr)) >>> 0;
};

const isIpv4InCidrHostRange = (ip: string, baseIp: string, cidr: number): boolean => {
  const ipInt = ipv4ToInt(ip);
  const baseInt = ipv4ToInt(baseIp);
  const maskInt = cidrToMaskInt(cidr);
  if (ipInt == null || baseInt == null || maskInt == null) return false;

  const network = (baseInt & maskInt) >>> 0;
  const broadcast = (network | (~maskInt >>> 0)) >>> 0;

  if (cidr === 32) return ipInt === network;
  if (cidr === 31) return ipInt >= network && ipInt <= broadcast;

  const firstHost = (network + 1) >>> 0;
  const lastHost = (broadcast - 1) >>> 0;
  return ipInt >= firstHost && ipInt <= lastHost;
};
const fieldPoolIpV6YupValidation = yup
  .string()
  .matches(
    /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^::(?:[0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4}$|^[0-9a-fA-F]{1,4}::(?:[0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4}$|^::(?:[0-9a-fA-F]{1,4}:){0,5}[0-9a-fA-F]{1,4}:(?:[0-9]{1,3}\.){3}[0-9]{1,3}$|^(?:(?::[0-9a-fA-F]{0,4}){0,6})?::(?:[0-9a-fA-F]{1,4}:){0,5}[0-9a-fA-F]{1,4}(\/\d{1,3})?$/,
    'Invalid IPv6 address'
  )
  .required('El pool de IP es Requerido')
  .max(50, 'El pool de IP debe tener como máximo 50 caracteres');

const geographyCodeSchema = yup
  .string()
  .max(5, 'El código del país debe tener menos de 5 caracteres')
  .optional();
export const codigoModel = yup
  .string()
  .max(60, 'La longitud máxima es 60 caracteres')
  .required('El código es requerido');

///* Documents type
export const newDoctypeSchema = yup.object({
  nombre: fieldNameYupValidation,
});

///* Promociones
export const newPromocionSchema = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation,
  //codigo: codeModelYupValidation,
  estado: fieldStateYupValidation,

  recurrencia: yup.string().optional(),

  tipo_descuento: yup.string().required('El tipo de descuento es Requerido'),
  valor_descuento: yup
    .number()
    .typeError('El valor de descuento es Requerido')
    .required('El valor de descuento es Requerido')
    .min(0, 'El valor mínimo es 0'),

  fecha_inicio: yup
    .date()
    .typeError('La fecha de inicio es requerida')
    .required('La fecha de inicio es requerida'),
  fecha_fin: yup.string().optional().nullable(),

  prioridad: yup
    .number()
    .typeError('La prioridad es Requerida')
    .required('La prioridad es Requerida')
    .min(1, 'El valor mínimo es 1'),
});

///* Payment methods
export const newPaymentMethodSchema = yup.object({
  //codigo: yup.string().required("El código es requerido"),
  nombre: yup.string().required("El nombre es requerido"),
  tipo_contrato: yup.string().required("El tipo de contrato es requerido"),
  forma_pago: yup.string().required("La forma de pago es requerida"),
  estado: fieldStateYupValidation,
  // entidad_financiera: yup.string().required("La entidad financiera es requerida"),
});

////* Recurrencia
export const newRecurrenciaSchema = yup.object({
  nombre: fieldNameYupValidation,
});

///* Zones
export const newZoneSchema = yup.object({
  nombre: fieldNameYupValidation,
  numero_referencia: yup.string().required('El número de refencia es requerido'),
  estado: fieldStateYupValidation,
  pais: yup.string().required('El país es Requerido'),
  provincia: yup.string().required('La provincia es requerida'),
  parroquia: yup.string().optional().nullable(),
  ciudad: yup.string().required('La ciudad es requerida'),
});

///* Plan types
export const newPlanTypeSchema = yup.object({
  nombre: fieldNameYupValidation,
  permanencia: yup
    .number()
    .typeError('La permanencia es requerida')
    .required('La permanencia es requerida')
    .min(1, 'Debe ser mayor a 0'),
});

///* Sectors
export const newSectorSchema = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation,
  estado: fieldStateYupValidation,
  // fk
  pais: yup.string().required('El país es Requerido'),
  provincia: yup.string().required('La provincia es requerida'),
  ciudad: yup.string().required('La ciudad es requerida'),
  parroquia: yup.string().optional().nullable(),
  zona: yup.string().required('La zona es requerida'),
});

///* Velocidades
export const newVelocidadSchema = yup.object({
  nombre: fieldNameYupValidation,
  medida_velocidad: yup
    .string()
    .required('La medida de velocidad es requerida'),
  estado: fieldStateYupValidation,
});
////* IPv4
export const newIpv4Schema = yup.object({
  nombre: fieldNameYupValidation,
  //codigo: codeModelYupValidation,
  estado: fieldStateYupValidation,
  tipo_uso: yup.string().required('El tipo de IP es Requerido'),
  routers: yup.array().of(yup.string().required()).min(1, 'Selecciona al menos un router').required('Campo requerido'),
  // bras: yup.string().required('El Brass Requerido'),
  ipv_4: fieldPoolIpV4YupValidation,
  cidr: yup
    .number()
    .typeError('El CIDR es Requerido')
    .required('El CIDR es Requerido')
    .max(32, 'El CIDR debe tener como valor máximo 32')
    .min(1, 'El CIDR debe tener como valor mínimo 1'),
});

export const grupoIpv4Schema = yup.object({
  nombre: fieldNameYupValidation,
  gateway: fieldPoolIpV4YupValidation
    .required('El campo gateway es requerido')
    .test(
      'gateway-in-pool',
      'El gateway debe estar dentro del pool definido por IPv4 y CIDR',
      function (value) {
        if (!value) return true;

        const parent = this.parent as any;
        const ipv4 = parent?.ipv_4;
        const cidr = parent?.cidr;

        if (!ipv4 || cidr == null || cidr === '') return true;

        return isIpv4InCidrHostRange(String(value), String(ipv4), Number(cidr));
      }
    ),
  ipv_4: fieldPoolIpV4YupValidation.required('El campo ipv4 es requerido'),
  vlan: yup.string().required('El campo vlan es requerido'),
  cidr: yup
    .number()
    .typeError('El CIDR es Requerido')
    .required('El CIDR es Requerido')
    .max(30, 'El CIDR debe tener como valor máximo 30')
    .min(15, 'El CIDR debe tener como valor mínimo 15'),
});

export const newIpv6Schema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
  ipv_6: fieldPoolIpV6YupValidation,
  //codigo: codeModelYupValidation,
  cidr: yup
    .number()
    .typeError('El CIDR es Requerido')
    .required('El CIDR es Requerido')
    .max(128, 'El CIDR debe tener como valor máximo 128')
    .min(1, 'El CIDR debe tener como valor mínimo 1'),
  tipo_uso: yup.string().required('El tipo de uso es requerido'),
});


///* Internet Plans
export const newPlanSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
  codigo: codigoModel,

  velocidad_descarga_maxima: yup
    .number()
    .typeError('La velocidad de descarga máxima es Requerida')
    .required('La velocidad de descarga máxima es Requerida')
    .min(0, 'El valor mínimo es 0'),
  velocidad_descarga_minima: yup
    .number()
    .typeError('La velocidad de descarga mínima es Requerida')
    .required('La velocidad de descarga mínima es Requerida')
    .min(0, 'El valor mínimo es 0'),
  velocidad_subida_maxima: yup
    .number()
    .typeError('La velocidad de subida máxima es Requerida')
    .required('La velocidad de subida máxima es Requerida')
    .min(0, 'El valor mínimo es 0'),
  velocidad_subida_minima: yup
    .number()
    .typeError('La velocidad de subida mínima es Requerida')
    .required('La velocidad de subida mínima es Requerida')
    .min(0, 'El valor mínimo es 0'),
  comparticion: yup
    .string()
    .required('La compartición es Requerida')
    .max(50, 'La longitud máxima es 50 caracteres'),
  valor: yup
    .number()
    .typeError('El valor es Requerido')
    .required('El valor es Requerido')
    .min(0, 'El valor mínimo es 0'),

  es_discapacidad: yup
    .boolean()
    .typeError('Discapacidad es Requerido')
    .required('Discapacidad es Requerido'),
  es_tercera_edad: yup
    .boolean()
    .typeError('Tercera Edad es Requerido')
    .required('Tercera Edad es Requerido'),

  // fk
  permanencia: yup.string().required('La permanencia es Requerida'),
  tipo_servicio: yup.string().required('El tipo de servicio es Requerido'),
  tipo_plan: yup.string().required('El tipo de plan es Requerido'),
  unidad: yup.string().required('La unidad es Requerida'),

  // no va dentro del plan
  // grupo_ipv4: yup.string().required('El grupo IPv4 es Requerido'),
  // grupo_ipv6: yup.string().optional().nullable(),
});

///* Coberturas
export const newCoberturaSchema = yup.object({
  provincia: yup.string().required('La provincia es requerida'), // name is the fk
  ciudad: yup.string().required('La ciudad es requerida'), // name is the fk
  zona: yup // ID is the fk
    .number()
    .typeError('La zona es requerida')
    .required('La zona es requerida'),
  sector: yup // ID is the fk
    .number()
    .typeError('El sector es Requerido')
    .required('El sector es Requerido'),
});

export const newTipoOrdenTrabajo = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation,
});

///* geography
export const newCountrySchema = yup.object({
  nombre: fieldNameYupValidation,
  codigo: yup
    .string()
    .required('El código es Requerido')
    .min(2, 'Min 2 characteres')
    .max(50, 'La longitud máxima es 50 caracteres'),
  estado: fieldStateYupValidation,
  nacionalidad: yup
    .string()
    .required('La nacionalidad es Requerida')
    .min(2, 'Min 2 characteres')
    .max(50, 'La longitud máxima es 50 caracteres'),
  cobertura: yup.boolean().required('Campo Obligatorio'),
});

export const newProvinceSchema = yup.object({
  nombre: fieldNameYupValidation,
  //codigo: geographyCodeSchema,
  pais: yup.string().required('El país es Requerido'),
  estado: fieldStateYupValidation,
});
export const newObservacionSchema = yup.object({
  nombre_observacion: fieldNameYupValidation,
});
export const newResponsablev2Schema = yup.object({
  tipo_responsable: yup
    .string()
    .required("El tipo es obligatorio"),
  estado: yup.boolean(),
});
//** */
export const newSolicitudClienteCorporativo = yup.object({
  clientes: yup.array().of(
    yup.object({
      cliente_oficina: yup.string().required('Cliente es requerido'),
      ciudad: yup.string().required('Ciudad es requerida'),
      telefono: yup
        .string()
        .required('El teléfono es requerido')
        .matches(/^(09\d{8}|0[2-7]\d{7})$/, 'Debe ser un número válido de Ecuador'),


      direccion: yup.string().required('Dirección requerida'),
      contacto_sitio: yup.string().required('Contacto requerido'),

      sucursales: yup.array().of(
        yup.object({
          nombre_sucursal: yup.string().required('Sucursal requerida'),

          velocidad: yup
            .number()
            .typeError('Debe ser número')
            .positive('Debe ser mayor a 0')
            .required('Velocidad requerida'),

          servicio: yup.string().required('Servicio requerido'),

          coordenadas: yup.string().required('Coordenadas requeridas'),
        })
      ).min(1, 'Debe haber al menos una sucursal'),
    })
  ).min(1, "Debe haber al menos un cliente").required('Debe haber al menos un cliente'),
});


export const newComentariosSolicitudCorporativo = yup.object({
  comentario_general: yup
    .string()
    .required('El comentario general es obligatorio'),

  complejidad: yup
    .string()
    .oneOf(['BAJA', 'MEDIA', 'ALTA'], 'Seleccione una complejidad válida')
    .required('Debe seleccionar la complejidad'),

  clientes: yup.array().of(
    yup.object({
      id_solicitud_cliente: yup.string().required(),

      sucursales: yup.array().of(
        yup.object({
          id_solicitud_sucursal: yup.string().required(),

          comentario: yup
            .string()
            .required('Debe ingresar un comentario'),
        })
      )
    })
  )
});
/** */



export const newCitySchema = yup.object({
  nombre: fieldNameYupValidation,
  //codigo: yup.string().required('El código es Requerido'),
  estado: fieldStateYupValidation,
  pais: yup.string().required('El país es Requerido'), // code
  provincia: yup.string().required('La provincia es requerida'), // code
});

///* Services type
export const newServiceTypeSchema = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation,
  discapacidad: yup.boolean().required('Campo Obligatorio'),
  tercera_edad: yup.boolean().required('Campo Obligatorio'),
});

///* Tipos de Informe
export const newTipoInformeSchema = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation,
});

///* Estados de Informe
export const newEstadoInformeSchema = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation,
});

///* Tipos de Instalación
export const newTipoInstalacionSchema = yup.object({
  nombre: fieldNameYupValidation,
  ///codigo: codeModelYupValidation,
  estado: fieldStateYupValidation,
  valor: yup.number().typeError('El valor debe ser un número').optional(),
});

///* Marcas de Vehículos
export const newMarcaVehiculoSchema = yup.object({
  nombre: fieldNameYupValidation,
});

///* flota
export const newFlotaSchema = yup.object({
  lider: yup
    .string()
    .test('trim', 'El lider es Requerido', value => {
      const trimmedValue = value ? value.trim() : '';
      return trimmedValue.length > 0;
    })
    .required('El lider es Requerido')
    .max(100, 'La longitud máxima es 100 caracteres'),
  pais: yup.string().required('El país es Requerido'),
  //codigo: codigoModel,
  nombre: yup.string().required('El nombre es Requerido'),
  estado: fieldStateYupValidation,
  auxiliar: yup
    .string()
    .test('trim', 'El auxiliar es Requerido', value => {
      const trimmedValue = value ? value.trim() : '';
      return trimmedValue.length > 0;
    })
    .required('El auxiliar es Requerido')
    .max(100, 'La longitud máxima es 100 caracteres')
    .test(
      'isUppercase',
      'El valor debe estar en mayúsculas',
      value => value === value?.toUpperCase()
    ),
  telefono_1: yup
    .string()
    .required('El teléfono 1 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),

  telefono_2: yup
    .string()
    .required('El teléfono 1 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador')
    .test(
      'no-repetir',
      'No se puede repetir el número de teléfono 1',
      function (value) {
        const otrosNumeros = [this.parent.telefono_1].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),
  email: emailYupValidation,
  // numero_contrato_flota: yup
  //   .string()
  //   .required('El número de contrato es Requerido')
  //   .max(100, 'La longitud máxima es 100 caracteres'),
  placa_vehiculo: yup
    .string()
    .required('La placa es requerida')
    .max(100, 'La longitud máxima es 100 caracteres'),
  modelo_vehiculo: yup
    .string()
    .required('El modelo es Requerido')
    .max(200, 'La longitud máxima es 200 caracteres'),
  anio_vehiculo: yup
    .number()
    .typeError('El año es Requerido')
    .required('El año es Requerido')
    .min(1970, 'El año debe ser mayor a 1970')
    .max(new Date().getFullYear() + 30, 'Excede el año permitido'),
  color_vehiculo: yup
    .string()
    .required('El color es Requerido')
    .max(200, 'La longitud máxima es 200 caracteres'),

  es_bodega: yup
    .boolean()
    .typeError('Es bodega es Requerido')
    .required('Es bodega es Requerido'),

  dia_pico_placa: yup.number().when('aplicar_pico_placa', {
    is: (aplicar_pico_placa: boolean) => aplicar_pico_placa,
    then: schema => schema.required('Campo obligatorio'),
  }).optional().nullable(),
  hora_inicio_pico_placa_1: yup.string().when('aplicar_pico_placa', {
    is: (aplicar_pico_placa: boolean) => aplicar_pico_placa,
    then: schema => schema.required('Campo obligatorio'),
  }).optional().nullable(),
  hora_fin_pico_placa_1: yup.string().when('aplicar_pico_placa', {
    is: (aplicar_pico_placa: boolean) => aplicar_pico_placa,
    then: schema => schema.required('Campo obligatorio'),
  }).optional().nullable(),
  hora_inicio_pico_placa_2: yup.string().when('aplicar_pico_placa', {
    is: (aplicar_pico_placa: boolean) => aplicar_pico_placa,
    then: schema => schema.required('Campo obligatorio'),
  }).optional().nullable(),
  hora_fin_pico_placa_2: yup.string().when('aplicar_pico_placa', {
    is: (aplicar_pico_placa: boolean) => aplicar_pico_placa,
    then: schema => schema.required('Campo obligatorio'),
  }).optional().nullable(),


  dia_cuadre: yup.number().when('aplicar_cuadre', {
    is: (aplicar_cuadre: boolean) => aplicar_cuadre,
    then: schema => schema.required('Campo obligatorio'),
  }).optional().nullable(),
  hora_inicio_cuadre: yup.string().when('aplicar_cuadre', {
    is: (aplicar_cuadre: boolean) => aplicar_cuadre,
    then: schema => schema.required('Campo obligatorio'),
  }).optional().nullable(),
  hora_fin_cuadre: yup.string().when('aplicar_cuadre', {
    is: (aplicar_cuadre: boolean) => aplicar_cuadre,
    then: schema => schema.required('Campo obligatorio'),
  }).optional().nullable(),

  materiales_disponibles: yup.string().optional().nullable(), // JSON

  ///* fk
  marca_vehiculo: yup.string().required('La marca de vehículo es requerida'),
  provincia: yup.string().required('La provincia es requerida'), // code is the fk
  ciudad: yup.string().required('La ciudad es requerida'), // code is the fk
  //zona: yup.string().required('La zona es requerida'), // code

  // USER: no post <- area-departamento-cargo-userProfile
  area: yup.string().required('El área es requerida'),
  departamento: yup.string().required('El departamento es Requerido'),

  // bodega
  bodega: yup.string().when('es_bodega', {
    is: (es_bodega: boolean) => es_bodega,
    then: schema => schema.required('La bodega externa es Requerida'),
  }).optional().nullable(),
  zonas_select: yup.array().of(yup.object().required('Campo requerido')).min(1, 'Selecionar al menos una zona.')
});

///* Empresas
export const newEmpresaSchema = yup.object({
  tipo_identificacion: yup
    .string()
    .required('El tipo de identificación es Requerido'),
  identificacion: yup.string().required('La identificación es requerida'),

  // make razon_social required if tipo_documento is RUC
  razon_social: yup
    .string()
    .when('tipo_documento', {
      is: 'RUC',
      then: schema =>
        schema
          .required('La razón social es requerida')
          .max(100, 'La longitud máxima es 100 caracteres'),
    })
    .optional(),
  identificacion_representante: yup
    .string()
    .required('La identificación del representante es Requerida')
    .max(54, 'La longitud máxima es 54 caracteres'),
  razon_social_representante: yup
    .string()
    .required('La razón social del representante es Requerida')
    .max(100, 'La longitud máxima es 100 caracteres'),

  nombre_comercial: yup.string().required('El nombre comercial es Requerido'), // unique

  email_representante: emailYupValidation,
  telefono_representante: yup
    .string()
    .required('El teléfono del representante es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador')
    .test(
      'no-repetir',
      'No se puede repetir el número del representante',
      function (value) {
        const otrosNumeros = [
          this.parent.telefono_representante_2,
          this.parent.telefono_representante_3,
        ].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),

  telefono_1: yup
    .string()
    .required('El teléfono 1 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador')
    .test(
      'no-repetir',
      'No se puede repetir el número de teléfono 1',
      function (value) {
        const otrosNumeros = [
          this.parent.telefono_2,
          this.parent.telefono_3,
        ].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),
  telefono_2: yup
    .string()
    .required('El teléfono 1 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador')
    .test(
      'no-repetir',
      'No se puede repetir el número de teléfono 1',
      function (value) {
        const otrosNumeros = [
          this.parent.telefono_1,
          this.parent.telefono_3,
        ].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),
  telefono_3: yup
    .string()
    .optional()
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador')
    .test(
      'no-repetir',
      'No se puede repetir el número de teléfono 1',
      function (value) {
        const otrosNumeros = [
          this.parent.telefono_1,
          this.parent.telefono_2,
        ].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),

  logo: yup.string().optional(), // url
  contador: yup.string().required('El contador es Requerido'),

  direccion: yup.string().required('La dirección es requerida'),
  email: emailYupValidation,

  ///* fk

  tipo_regimen: yup.string().required('El tipo de régimen es Requerido'),

  // cedula
  pais: yup.string().required('El país es Requerido'),
  provincia: yup.string().required('La provincia es requerida'),
  ciudad: yup.string().required('La ciudad es requerida'),

  es_agente_retencion: yup
    .boolean()
    .typeError('Es agente de retención es Requerido')
    .required('Es agente de retención es Requerido'),
  numero_agentes_retencion: yup
    .number()
    .typeError('Número de agente de retención inválido')
    .when('es_agente_retencion', {
      is: true,
      then: schema =>
        schema
          .required('Número de agente de retención es Requerido')
          .min(1, 'Debe ser mayor a 0'),
    })
    .optional(),
});

///* Canales de Venta
export const newCanalVentaSchema = yup.object({
  nombre: fieldNameYupValidation,
  codigo: codeModelYupValidation,
  supervisor: yup
    .string()
    .optional()
    .nullable()
    .max(100, 'La longitud máxima es 100 caracteres'),
  estado: fieldStateYupValidation,
});

///* iva
export const newIvaSchema = yup.object({
  nombre: fieldNameYupValidation,
  // porcentaje: yup
  //   .number()
  //   .typeError('El porcentaje es Requerido')
  //   .required('El porcentaje es Requerido')
  //   .min(0, 'Debe ser de al menos 0%')
  //   .max(100, 'Debe ser menor a 100%'),
  estado: fieldStateYupValidation,
  sri_codigo: yup
    .string()
    .required('El código del SRI es Requerido')
    .min(3, 'Min 3 characteres')
    .max(50, 'La longitud máxima es 50 caracteres'),

  sri_codigo_porcentaje: yup
    .string()
    .required('El código del SRI es Requerido'),

  porcentaje: yup
    .string()
    .required('El porcentaje es Requerido')
    // test if is a number
    .test(
      'isNumber',
      'El porcentaje debe ser un número',
      value => !isNaN(Number(value))
    )
    // test min number 0 and max number 100
    .test(
      'isBetween',
      'El porcentaje debe estar entre 0 y 100',
      value => Number(value) >= 0 && Number(value) <= 100
    ),

  /* codigo: codigoModel, */
  numero_referencia: yup.string().optional(),
});

///* nacionalidades
export const newNacionalidadSchema = yup.object({
  nombre: fieldNameYupValidation,
  codigo: geographyCodeSchema,
  pais: yup.string().required('El país es Requerido'),
});

///* confirmar preagendamiento pyl
export const updAgendaInstalacionPylSchema = yup.object({
  fecha: yup.string().required('La fecha es requerida'),
  fecha_hora_instalacion: yup
    .string()
    .required('La fecha y hora de instalación son requeridas'),

  fullName: yup.string().required('El nombre es Requerido'),

  // creado tras ok pyl - auto back
  numero_contrato: yup.string().optional(),
  url_contrato: yup.string().optional(),

  identificacion: yup.string().required('La identificación es requerida'),
  fecha_nacimiento: yup
    .string()
    .required('La fecha de nacimiento es requerida'),
  edad: yup.number().required('La edad es requerida'),
  direccion: yup.string().required('La dirección es requerida'),
  coordenadas: yup.string().required('Las coordenadas son requeridas'),
  condicion_residencia: yup
    .string()
    .required('La condición de residencia es requerida'),

  celular: yup.string().required('El celular es Requerido'),
  // telefono_adicional: yup.string().optional(),
  email: emailYupValidation,
  parentesco_referencia: yup
    .string()
    .required('El parentesco es Requerido')
    .max(15, 'La longitud máxima es 15 caracteres'),
  persona_referencia: yup
    .string()
    .required('La persona de referencia es requerida'),
  celular_referencia: yup
    .string()
    .required('El celular de referencia es Requerido'),
  telefono_fijo_referencia: yup.string().optional(),
  telefono_fijo: yup.string().optional(),
  velocidad_internet: yup
    .string()
    .required('La velocidad de internet es requerida'),

  valor_instalacion: yup
    .string()
    .required('El valor de instalación es Requerido'),
  valor_instalacion_sin_iva: yup
    .string()
    .required('El valor de instalación sin IVA es Requerido'),
  valor_instalacion_total: yup
    .string()
    .required('El valor total de instalación es Requerido'),
  segmentacion: yup.string().required('La segmentación es requerida'),
  puntaje_empresa: yup
    .string()
    .required('El puntaje de la empresa es Requerido'),

  distancia_aproximada: yup
    .string()
    .required('La distancia aproximada es requerida'),
  detalle_instalacion: yup
    .string()
    .required('El detalle de instalación es Requerido'),
  herramienta_utilizada: yup
    .string()
    .required('La herramienta utilizada es requerida'),
  numero_pisos: yup.number().required('El número de pisos es Requerido'),
  numero_dispositivos: yup
    .number()
    .required('El número de dispositivos es Requerido'),
  tipo_uso: yup.string().required('El tipo de uso es Requerido'),
  tipo_vivienda: yup.string().required('El tipo de vivienda es Requerido'),
  como_se_entero: yup.string().required('Cómo se enteró es Requerido'),
  valor_plan: yup.string().required('El valor del plan es Requerido'),
  bloquear_hasta: yup.string().optional().nullable(),

  estado_pil: yup
    .number()
    .typeError('El estado PyL es Requerido')
    .required('El estado PyL es Requerido'),
  motivo: yup
    .string()
    .when('estado_pil', {
      is: EstadoPyLCodigoEnum.RECHAZADO,
      then: schema =>
        schema
          .required('El motivo es Requerido')
          .max(350, 'La longitud máxima es 350 caracteres'),
    })
    .optional()
    .nullable(),

  estado_llamada: yup.string().required('El estado de la llamada es Requerido'),
  observacion_llamada: yup
    .string()
    .required('La observación de la llamada es Requerida'),

  ///* fk
  prospecto: yup.number().required('El prospecto es Requerido'),
  preventa: yup.number().required('La preventa es requerida'),
  flota: yup
    .number()
    .typeError('La flota es requerida')
    .required('La flota es requerida'),
  plan: yup
    .number()
    .typeError('El plan es Requerido')
    .required('El plan es Requerido'),

  // user logueado - quien crea la agenda
  user: yup.number().optional().nullable(),
  tipo_documento: yup.string().required('El tipo de documento es Requerido'),
  tipo_servicio: yup.string().required('El tipo de servicio es Requerido'),
  tipo_instalacion: yup
    .string()
    .required('El tipo de instalación es Requerido'),

  nap: yup.string().required('El NAP es Requerido'),
  nacionalidad: yup.string().required('La nacionalidad es requerida'),
  pais: yup.string().required('El país es Requerido'),
  provincia: yup.string().required('La provincia es requerida'),
  ciudad: yup.string().required('La ciudad es requerida'),

  zona: yup
    .number()
    .typeError('La zona es requerida')
    .required('La zona es requerida'),
  sector: yup
    .number()
    .typeError('El sector es Requerido')
    .required('El sector es Requerido'),

  cliente: yup.string().optional(),

  // helpers
  zonaLabel: yup.string().optional(),
  sectorLabel: yup.string().optional(),
  celularPrincipal: yup.string().optional(),
  // latitud: yup.string().required('La latitud es requerida'),
  // longitud: yup.string().required('La longitud es requerida'),
  forma_pago: yup.string().optional(),
});

export const updAgendaInstalacionPylRechazoSchema = yup.object({
  motivo: yup
    .string()
    .required('El motivo de rechazo es Requerido')
    .max(350, 'La longitud máxima es 350 caracteres'),
  estado_pil: yup
    .number()
    .typeError('El estado PyL es Requerido')
    .required('El estado PyL es Requerido'),
});

///* orden_trabajo tecnico/instalaciones/asignaciones
export const ordenTrabajoTecnicoInstalacionAsignadaSchema = yup.object({
  fecha_hora_instalacion: yup
    .string()
    .required('La fecha y hora de instalación es requerida'),
  coordenadas: yup.string().required('Las coordenadas son requeridas'),
  cliente: yup.string().required('El cliente es Requerido'),
  numero_documento: yup
    .string()
    .required('El número de documento es Requerido'),
  email: emailYupValidation,
  telefono_fijo: yup.string().required('El teléfono fijo es Requerido'),
  celular: yup.string().required('El celular es Requerido'),
  persona_referencia: yup
    .string()
    .required('La persona de referencia es requerida'),
  celular_referencia: yup
    .string()
    .required('El celular de referencia es Requerido'),
  parentesco_referencia: yup
    .string()
    .required('El parentesco de referencia es Requerido'),
  direccion: yup.string().required('La dirección es requerida'),
  // mensualidad_sin_iva: yup
  //   .number()
  //   .required('La mensualidad sin IVA es requerida'),
  valor_instalacion: yup
    .number()
    .typeError('El valor de instalación es Requerido')
    .required('El valor de instalación es Requerido'),
  valor_plan: yup
    .number()
    .typeError('El valor del plan es Requerido')
    .required('El valor del plan es Requerido'),
  tipo_instalacion: yup
    .string()
    .required('El tipo de instalación es Requerido'),

  direccion_ip: yup.string().required('La dirección IP es requerida'),
  ip_publica: yup.string().required('La IP pública es requerida'),
  tipo_cuenta: yup.string().required('El tipo de cuenta es Requerido'),
  orden_trabajo_foto: yup
    .string()
    .required('La foto de la orden de trabajo es requerida'),
  potencia_ont: yup.string().required('La potencia de ONT es requerida'),
  test_5g: yup.string().required('El test 5G es Requerido'),
  pon_serial_ont: yup.string().required('El serial PON de ONT es Requerido'),
  croquis_virtual: yup.string().required('El croquis virtual es Requerido'),
  materiales_contrato: yup
    .string()
    .required('Los materiales de contrato son Requeridos'),
  ubicacion_equipo_ac: yup
    .string()
    .required('La ubicación del equipo AC es requerida'),
  serial_mac_ac: yup.string().required('El serial MAC de AC es Requerido'),
  serie: yup.string().required('La serie es requerida'),
  modelo: yup.string().required('El modelo es Requerido'),
  marca: yup.string().required('La marca es requerida'),
  splitter: yup.string().required('El splitter es Requerido'),
  manga: yup.string().required('La manga es requerida'),
  gpon: yup.string().required('El GPON es Requerido'),
  olt: yup.string().required('El OLT es Requerido'),
  color_hilo: yup.string().required('El color de hilo es Requerido'),
  num_hilo: yup.string().required('El número de hilo es Requerido'),
  potencia_dbm: yup.string().required('La potencia en dBm es requerida'),
  distancia: yup.string().required('La distancia es requerida'),
  conexion_tierra: yup.string().required('La conexión a tierra es requerida'),
  regulador: yup.string().required('El regulador es Requerido'),
  otros_materiales: yup.string().required('Otros materiales son Requeridos'),
  observacion: yup.string().required('La observación es requerida'),
  bloquear_hasta: yup.string().optional(),

  ///* fk
  agenda: yup.number().required('La agenda es requerida'),
  ciudad: yup.string().required('La ciudad es requerida'),
  sector: yup.number().required('El sector es Requerido'),
  flota: yup.number().required('La flota es requerida'),
  plan: yup.number().required('El plan es Requerido'),
  nap: yup.string().required('El NAP es Requerido'),
  tipo_orden_trabajo: yup
    .string()
    .required('El tipo de orden de trabajo es Requerido'),
  tipo_documento: yup.string().required('El tipo de documento es Requerido'),
  tipo_informe: yup.string().required('El tipo de informe es Requerido'),
  // estado_informe: yup.string().required('El estado de informe es Requerido'),
  nacionalidad: yup.string().required('La nacionalidad es requerida'),

  forma_pago: yup.string().required('La forma de pago es requerida'),
  banco: yup.string().required('El banco es Requerido'),

  ///* helpers
  identificacion: yup.string().optional(),

  ubicacion_ont: yup.string().required('La ubicación de ONT es requerida'),
  latitudONT: yup.string().required('La latitud de ONT es requerida'),
  longitudONT: yup.string().required('La longitud de ONT es requerida'),
  flotaLabel: yup.string().optional(),
});

//grupo-proveedores
export const newProveedorSchema = yup.object({
  nombre: fieldNameYupValidation,
  //descripcion
  descripcion: yup.string().required('Campo Requerido'),
  estado: fieldStateYupValidation,
});
//tipo proveedores
export const newTypeProveedorSchema = yup.object({
  nombre: fieldNameYupValidation,
  //descripcion
  descripcion: yup.string().required('Campo Requerido'),
  estado: fieldStateYupValidation,
});

// RECHAZO POR DATOS INCORECTOS
export const newRechazoDatosIncorrectosSchema = yup.object({
  tipo_documento: yup.string().required('Campo Requerido'),
  identificacion: yup.string().required('Campo Requerido'),
  nombre: yup.string().required('Campo Requerido'),
  condicion_residencia: yup.string().required('Campo Requerido'),
  pais: yup.string().required('Campo Requerido'),
  provincia: yup.string().required('Campo Requerido'),
  ciudad: yup.string().required('Campo Requerido'),
  zona: yup
    .number()
    .typeError('La zona es Requerido')
    .required('La zona es Requerido'),
  sector: yup
    .number()
    .typeError('El sector es Requerido')
    .required('El sector es Requerido'),
  direccion: yup.string().required('Campo Requerido'),
  persona_referencia: yup.string().required('Campo Requerido'),
  celular: yup
    .string()
    .required('Este campo es obligatorio')
    .min(10, 'Número menor a 10 digitos')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"')
    .matches(/^[0-9]+$/, 'Ingresar un número válido')
    .test(
      'no-repetir',
      'Este número ya está siendo utilizado',
      function (value) {
        const otrosNumeros = [
          this.parent.telefono_fijo,
          this.parent.celular_referencia,
          this.parent.telefono_fijo_referencia,
        ].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),
  telefono_fijo: yup
    .string()
    .required('Este campo es obligatorio')
    .min(10, 'Número menor a 10 digitos')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"')
    .matches(/^[0-9]+$/, 'Ingresar un número válido')
    .test(
      'no-repetir',
      'Este número ya está siendo utilizado',
      function (value) {
        const otrosNumeros = [
          this.parent.celular,
          this.parent.celular_referencia,
          this.parent.telefono_fijo_referencia,
        ].filter(Boolean); // Filtrar valores opcionales

        return !otrosNumeros.includes(value);
      }
    ),
  celular_referencia: yup
    .string()
    .required('Este campo es obligatorio')
    .min(10, 'Número menor a 10 digitos')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"')
    .matches(/^[0-9]+$/, 'Ingresar un número válido')
    .test(
      'no-repetir',
      'Este número ya está siendo utilizado',
      function (value) {
        const otrosNumeros = [
          this.parent.celular,
          this.parent.telefono_fijo,
          this.parent.telefono_fijo_referencia,
        ].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),
  telefono_fijo_referencia: yup
    .string()
    .required('Este campo es obligatorio')
    .min(10, 'Número menor a 10 digitos')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"')
    .matches(/^[0-9]+$/, 'Ingresar un número válido')
    .test(
      'no-repetir',
      'Este número ya está siendo utilizado',
      function (value) {
        const otrosNumeros = [
          this.parent.celular,
          this.parent.telefono_fijo,
          this.parent.celular_referencia,
        ].filter(Boolean); // Filtrar valores opcionales
        return !otrosNumeros.includes(value);
      }
    ),
  forma_pago: yup.string().required('Campo Requerido'),
  num_tarjeta: yup
    .string()
    .when('codigo_forma_pago', {
      is: (formaPago: string) => formaPago === PaymentMethodEnum.TARJETA,
      then: schema =>
        schema
          .required('Campo Obligatorio')
          .max(24, 'La longitud máxima es 24 caracteres')
          .matches(/^[0-9]+$/, 'Ingresar una cuenta valida'),
    })
    .optional(),
  email: emailYupValidation,
  valor_instalacion: yup.string().required('Campo Requerido'),
  entidad_finciera: yup
    .string()
    .when('codigo_forma_pago', {
      is: PaymentMethodEnum.DEBITO,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional(),
  tipo_cuenta_bancaria: yup
    .string()
    .when('codigo_forma_pago', {
      is: PaymentMethodEnum.DEBITO,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional(),
  numero_cuenta: yup
    .string()
    .when('codigo_forma_pago', {
      is: PaymentMethodEnum.DEBITO,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional(),
});

// Tipo de régimen

export const newTypeRegimenSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
  ///codigo: yup.string().required('el codigo es requerido'),
});
//localidad proveedores

export const newLocalidadProveedoresSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
});
// sustentos tributarios
export const newSustentosTributariosSchema = yup.object({
  nombre: fieldNameYupValidation,
  //descripcion
  descripcion: yup.string().required('Campo Requerido'),
  estado: fieldStateYupValidation,
});
//Porcentaje Iva Servicios
export const newPorcentajeIvaServicesSchema = yup.object({
  porcentaje: yup
    .number()
    .typeError('El porcentaje es Requerido')
    .required('El porcentaje es Requerido')
    .min(1, 'Debe ser mayor al 0%')
    .max(100, 'Debe ser menor a 100%'),
  codigo: yup.string().required('el codigo es requerido'),
  estado: fieldStateYupValidation,
});
//categoria producto
export const newCategoryProductSchema = yup.object({
  nombre: fieldNameYupValidation,
  codigo: yup.string().required('el codigo es requerido'),
  estado: fieldStateYupValidation,
});
//proveedores
export const newProveedoresSchema = yup.object({
  tipo_identificacion: yup
    .string()
    .required('El tipo de identificación es Requerido'),
  identificacion: yup.string().required('La identificación es requerida'),
  nombre_comercial: yup
    .string()
    .required('El nombre comercial es requerido'),
  direccion: yup.string().required('La dirección es requerida'),
  razon_social: yup
    .string()
    .when('identificacion', {
      is: 'RUC',
      then: schema =>
        schema
          .required('La razón social es requerida')
          .max(100, 'La longitud máxima es 100 caracteres'),
    }).optional(),
  email: emailYupValidation,
  telefono_1: yup
    .string()
    .required('El teléfono 1 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  telefono_2: yup
    .string()
    .required('El teléfono 1 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  contacto: yup.string().required('El contacto es Requerido'),
  contacto_cargo: yup.string().required('El cargo del contacto es Requerido'),
  contacto_email_1: emailYupValidation,
  contacto_email_2: emailYupValidation,
  contacto_telefono_1: yup
    .string()
    .required('El teléfono 1 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  contacto_telefono_2: yup
    .string()
    .required('El teléfono 2 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  estado: fieldStateYupValidation,
  tipo_regimen: yup.string().required('El tipo regimen es Requerido'),
  pais: yup.string().required('El país es Requerido'),
  provincia: yup.string().required('La provincia es requerida'),
  ciudad: yup.string().required('La ciudad es requerida'),
  porcentaje_ret_iva_bienes: yup
    .string()
    .required('El porcentaje de retencion de IVA  de bienes es Requerido'),

  porcentaje_ret_iva_servicios: yup
    .string()
    .required('El porcentaje de retencion de IVA  de servicios es Requerido'),

  /*  descripcion_cuenta_banco: yup
   .string()
   .required('La descripción de cuenta es requerida'), 
   tipo_documento: yup.string().required('El tipo de documento es Requerido'),
 grupo_proveedor: yup.string().required('La grupo proveedor es requerida'),
 tipo_compra: yup.string().required('La tipo compra es requerida'),
 tipo_proveedor: yup.string().required('El tipo proveedor es Requerido'),
 forma_pago: yup.string().required('La forma pago es Requerido'),
 sustento_tributario: yup
   .string()
   .required('El sustento tributario es Requerido'),
 localidad_proveedor: yup
   .string()
   .required('La localidad del proveedor es requerida'),
 
 cargo: yup.string().required('El cargo es Requerido'), */
});
//tipo compras
export const newTypeComprasSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
});
//marca productos
export const newMarcaProductosSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
});
//modelos productos

export const newModelosProductosSchema = yup.object({
  estado: fieldStateYupValidation,
  nombre: yup.string().required('El nombre del modelo de producto es requerida'),
});

//base de datos
export const newDatabaseSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
  username: yup.string().required('El nombre de usuario es Requerido'),
  password: yup.string().required('La contraseña es requerida'),
  host: yup.string().required('El servidor es Requerido'),
  puerto: yup.string().required('El puerto es Requerido'),
});
//parametros smtp
export const newParametrosSmtpSchema = yup.object({
  host: yup.string().required('El servidor es Requerido'),
  port: yup.string().required('El puerto es Requerido'),
  username: yup.string().required('El nombre de usuario es Requerido'),
  email: yup.string().required('El correo es Requerido'),
  password: yup.string().required('La contraseña es requerida'),
  use_tls: yup.string().required('use_tsl es Requerido'),
  use_ssl: yup.string().required('use_ssl es Requerido'),
});
//motivos-ingreso
export const newMotivosSchema = yup.object({
  codigo: yup.string().required(' El codigo es Requerido'),
  nombre: yup.string().required('El nombre es Requerido'),
  modulo: yup.string().required('El modulo es Requerido'),
  prioridad: yup.string().required('La prioridad es Requeridad'),
  estado: fieldStateYupValidation,
});
//medidas-productos
export const newMedidasProductosSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
  siglas: yup.string().required('La nomenclatura es requerida'),
});
//areas

export const newAreasSchema = yup.object({
  nombre: fieldNameYupValidation,
  //codigo: yup.string().required('El codigo es requerido'),
  estado: fieldStateYupValidation,
  empresa: yup.string().required('La empresa es requerida'),
});
//departamentos

export const newDepartamentoSchema = yup.object({
  nombre: fieldNameYupValidation,
  area: yup.string().required('El área es requerida'),
  empresa: yup.string().required('La empresa es requerida'),
  estado: fieldStateYupValidation,
});

//centro-costo

export const newCentroCostoSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
});

//bodegas

export const newBodegasSchema = yup.object({
  nombre: yup.string().required('El nombre es requerido'),
  direccion: yup.string().required('La dirección es requerida'),
  estado: fieldStateYupValidation.required('El estado es Requerido'),
  es_externa: yup.boolean().required('El tipo de bodega es Requerido'),
  es_transito: yup.boolean().required('El tipo de transito es Requerido'),
  es_concecion_cliente: yup.boolean().required('El tipo de concepción cliente es Requerido'),

  pais: yup.string().required('El país es Requerido'),
  ciudad: yup.string().required('La ciudad es requerida'),
  provincia: yup.string().required('La provincia es requerida'),
  zona: yup.string().required('La zona es requerida'),
  sector: yup.string().required('El sector es requerido'),
  email: yup.string().email('Correo inválido').nullable().notRequired(),

  //email: yup.string().email().optional()
});

//naps
export const newNapsSchema = yup.object({
  nombre: yup.string().required('El nombre es requerido'),
  direccion: yup.string().required('La dirección es requerida'),
  coordenadas: yup.string().required('La coordenada es requerida'),
  latitud: yup.number().required('La latitud es requerida'),
  longitud: yup.number().required('La longitud es requerida'),
  estado_nap: yup.boolean().required("El soterrado es obligatorio").typeError('El soterrado es obligatorio'),
  proyecto_cod: yup.string().required('El proyecto codigo es requerido'),
  es_soterrado: yup.boolean().required("El soterrado es obligatorio").typeError('El soterrado es obligatorio'),
  nodo: yup.string().required('El nodo es requerido'),
  olt: yup.string().required('El olt es requerido'),
  sector: yup.string().required('El sector es requerido'),
  ciudad: yup.string().required('La ciudad es requerida'),
  estado: yup.boolean().required('El estado es requerido'),
});

//naps
export const newNapsCambioPuertosSchema = yup.object({
  nombre: yup.string().required('El nombre es requerido'),
  // direccion: yup.string().required('La dirección es requerida'),
  coordenadas: yup.string().required('La coordenada es requerida'),
  latitud: yup.number().required('La latitud es requerida'),
  longitud: yup.number().required('La longitud es requerida'),
  estado_nap: yup.boolean().required("El soterrado es obligatorio").typeError('El soterrado es obligatorio'),
  proyecto_cod: yup.string().required('El proyecto codigo es requerido'),
  es_soterrado: yup.boolean().required("El soterrado es obligatorio").typeError('El soterrado es obligatorio'),
  nodo: yup.string().required('El nodo es requerido'),
  olt: yup.string().required('El olt es requerido'),
  // sector: yup.string().required('El sector es requerido'),
  // ciudad: yup.string().required('La ciudad es requerida'),
  estado: yup.boolean().required('El estado es requerido'),
});

export const napsSchema = yup.object({
  // nombre: yup.string()
  //   .required("Requerido")
  //   .when("nombre_caja_primaria", {
  //     is: (val: string) => !!val, // Solo valida si nombre_caja_primaria existe
  //     then: (schema) => schema.test(
  //       "validacion-nombre",
  //       "El nombre no cumple con la estructura requerida",
  //       function (value) {
  //         const { nombre_caja_primaria } = this.parent;

  //         if (!value || !nombre_caja_primaria) return false;

  //         // Regex para formato: "LETRAS NUMEROS" (ej: "AB 1234")
  //         const matchPrimaria = nombre_caja_primaria.match(/^([A-Z]+)\s+(\d+)$/);
  //         const matchNombre = value.match(/^([A-Z]+)\s+(\d+)$/);

  //         if (!matchPrimaria || !matchNombre) {
  //           return this.createError({
  //             message: "El formato debe ser 'LETRAS NUMEROS' (ej: AB 1234)"
  //           });
  //         }

  //         const [, letrasPrimaria, numerosPrimaria] = matchPrimaria;
  //         const [, letrasNombre, numerosNombre] = matchNombre;

  //         // Validación 1: Primeras 2 letras iguales
  //         const mismasPrimerasDos = letrasNombre.slice(0, 2) === letrasPrimaria.slice(0, 2);
  //         if (!mismasPrimerasDos) {
  //           return this.createError({
  //             message: `Las primeras 2 letras deben ser "${letrasPrimaria.slice(0, 2)}"`
  //           });
  //         }

  //         const mismasLetras = letrasNombre.slice(0, 3) === letrasPrimaria.slice(0, 3);
  //         if (mismasLetras) {
  //           return this.createError({
  //             message: `No pueden ser las mismas letras"`
  //           });
  //         }

  //         // Validación 2: Base numérica igual (sin último dígito)
  //         const basePrimaria = numerosPrimaria.slice(0, -1);
  //         const baseNombre = numerosNombre.slice(0, -1);

  //         if (basePrimaria !== baseNombre) {
  //           return this.createError({
  //             message: `Los números deben comenzar con "${basePrimaria}"`
  //           });
  //         }

  //         // Validación 3: Último dígito entre 2-9
  //         const ultimoDigito = numerosNombre.slice(-1);
  //         if (!/^[2-9]$/.test(ultimoDigito)) {
  //           return this.createError({
  //             message: "El último dígito debe estar entre 2 y 9"
  //           });
  //         }

  //         return true;
  //       }
  //     ),
  //     otherwise: (schema) => schema // Sin validación extra si no hay caja_primaria
  //   }),

  nombre: yup.string()
    .required("Requerido")
    .when(
      ["nombre_caja_primaria", "nombre_operadora"],
      ([nombreCajaPrimaria, nombre_operadora], schema) => {
        // Si la nombre_operadora NO es FIBRAMAX, solo exigimos que sea obligatorio
        // y saltamos la validación del regex y la estructura
        if (nombre_operadora !== "FIBRAMAX") {
          return schema;
        }

        // Si no hay nombre_caja_primaria tampoco aplicamos la estructura especial
        if (!nombreCajaPrimaria) {
          return schema;
        }

        // Aplica las validaciones de regex/letras/números solo para FIBRAMAX
        return schema.test(
          "validacion-nombre",
          "El nombre no cumple con la estructura requerida",
          function (value) {
            if (!value) return false;

            // Regex para formato: "LETRAS NUMEROS" (ej: "AB 1234")
            const matchPrimaria = nombreCajaPrimaria.match(/^([A-Z]+)\s+(\d+)$/);
            const matchNombre = value.match(/^([A-Z]+)\s+(\d+)$/);

            if (!matchPrimaria || !matchNombre) {
              return this.createError({
                message: "El formato debe ser 'LETRAS NUMEROS' (ej: AB 1234)"
              });
            }

            const [, letrasPrimaria, numerosPrimaria] = matchPrimaria;
            const [, letrasNombre, numerosNombre] = matchNombre;

            // Validación 1: Primeras 2 letras iguales
            const mismasPrimerasDos = letrasNombre.slice(0, 2) === letrasPrimaria.slice(0, 2);
            if (!mismasPrimerasDos) {
              return this.createError({
                message: `Las primeras 2 letras deben ser "${letrasPrimaria.slice(0, 2)}"`
              });
            }

            const mismasLetras = letrasNombre.slice(0, 3) === letrasPrimaria.slice(0, 3);
            if (mismasLetras) {
              return this.createError({
                message: 'No pueden ser las mismas letras'
              });
            }

            // Validación 2: Base numérica igual (sin último dígito)
            const basePrimaria = numerosPrimaria.slice(0, -1);
            const baseNombre = numerosNombre.slice(0, -1);

            if (basePrimaria !== baseNombre) {
              return this.createError({
                message: `Los números deben comenzar con "${basePrimaria}"`
              });
            }

            // Validación 3: Último dígito entre 2-9
            const ultimoDigito = numerosNombre.slice(-1);
            if (!/^[2-9]$/.test(ultimoDigito)) {
              return this.createError({
                message: "El último dígito debe estar entre 2 y 9"
              });
            }

            return true;
          }
        );
      }
    ),
  // observacion_nap: yup.string().required('El campo de observación requerido'),
  coordenadas: yup.string().required('El campo coordenadas es requerido'),
  potencia: yup.number().moreThan(0, 'La potencia debe ser mayor a 0'),
});
//nodo
export const newNodoSchema = yup.object({
  //codigo: yup.string().required('El código es Requerido'),
  nombre: fieldNameYupValidation.required('El nombre es requerido'),
  direccion: yup.string().required('La dirección es requerida'),
  coordenadas: yup.string().required('La coordenada es requerida'),
  estado: fieldStateYupValidation.required('El estado es Requerido'),
  provincia: yup.string().required('La provincia es requerida'),
  ciudad: yup.string().required('El soterrado es requerido'),
  zona: yup.string().required('La zona es requerida'),
  sector: yup.string().required('El sector es requerido'),
  pais: yup.string().required('El pais es requerido'),
  es_bras: yup.boolean().required('Tiene bras es requerido'),
  bras: yup
    .string()
    .when('es_bras', {
      is: (es_bras: boolean) => es_bras,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional(),
});


export const nodosSchema = yup.object({
  //codigo: yup.string().required('El código es Requerido'),
  // olt: yup.string().required('El campo olt es requerido'),
  nombre: yup.string().required('El campo nombre es requerido'),
  direccion: yup.string().required('El campo direccion es requerido'),
  // zona: yup.string().required('El campo zona es requerido'),
  coordenadas: yup.string().required('El campo coordenadas es requerido'),
});


// destino-pedidos

export const newDestinoPedidosSchema = yup.object({
  nombre: fieldNameYupValidation.required('El nombre es Requerido'),
  descripcion: descriptionYupValidation.required('La descripción es requerida'),
  estado: fieldStateYupValidation.required('El estado es Requerido'),
});

// solicitudes-pedidos

export const newSolicitudesEgresoSchema = yup.object({
  //motivo: yup.string().required('La descripción es requerida'),
  /*   observacion: yup.string().required("La observación es requerida"),
   */ ubicacion: yup.string().required('La ubicación es requerida'),
  bodega: yup.string().required('La bodega es requerida'),

  /*   observacion: yup.string().required("La observación es requerida"),
   */
  //departamento: yup.number().required('El departamento es Requerido'),
  //tipo_compra: yup.number().required('El tipo de compra es Requerido'),
});
export const newICESchema = yup.object({
  codigo: yup.string().required('El código es Requerido'),
  nombre: fieldNameYupValidation.required('El nombre es Requerido'),
  sri_codigo: yup.string().required('el codigo sri es requerido'),
  sri_codigo_porcentaje: yup
    .number()
    .required('El porcentaje es Requerido')
    .min(0, 'Debe ser un número entre 0 y 100')
    .max(100, 'Debe ser un número entre 0 y 100'),
  porcentaje: yup
    .number()
    .required('El porcentaje es Requerido')
    .min(0, 'Debe ser un número entre 0 y 100')
    .max(100, 'Debe ser un número entre 0 y 100'),
  estado: fieldStateYupValidation.required('El estado es Requerido'),
});

export const newPlanificadorSchema = yup.object({});
export const newOrdenesCompraSchema = yup.object({
  concepto: yup.string().required('El concepto es requerido'),
  proveedor: yup.string().required('El proveedor es requerido'),
  plazo_pago: yup.string().required('El plazo pago es requerido'),
  solicitud_ingreso: yup.string().optional(),
  forma_pago: yup.string().required('La forma pago es requerida'),
});
export const newPresentacionSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
  descripcion: yup.string().required('La descripcion es requerida'),
});

export const newSubcategoriasProductosSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
  categoria_producto: yup
    .string()
    .required('La categoria de producto es requerida'),
});
export const newGruposProductosSchema = yup.object({
  nombre: fieldNameYupValidation,
  estado: fieldStateYupValidation,
});
export const newTipoProductosSchema = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation.required('La descripción es requerida'),
  codigo: yup.string().required('El codigo es requerido'),
});

export const newPlazaPagosSchema = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation.required('La descripción es requerida'),
});
export const newUbicacionesSchema = yup.object({
  nombre: yup.string().required('El nombre es requerido'),
  bodega: yup.string().required('La bodega es requerida'),
  numero_referencia: yup.string().optional(),
  estado: fieldStateYupValidation,
});

export const newEntidadesFinancierasSchema = yup.object({
  nombre: yup
    .string()
    .required('El nombre de la entidad financiera es requerida'),
  codigo_auxiliar: yup
    .string()
    .required('El codigo de la entidad financiera es requerida'),
  numero_referencia: yup
    .string()
    .required('El numero de referencia es requerida'),
});

export const newCooperativaSchema = yup.object({
  nombre: yup
    .string()
    .required('El nombre de la entidad financiera es requerida'),
  codigo_auxiliar: yup
    .string()
    .required('El codigo de la entidad financiera es requerida'),
  numero_referencia: yup
    .string()
    .required('El numero de referencia es requerida'),
  entidad_financiera: yup
    .string()
    .required('El numero de referencia es requerida'),
});

export const newMotivoRechazoSchema = yup.object({
  codigo: yup.string().required(' El codigo es Requerido'),
  nombre: yup.string().required('El nombre es Requerido'),
  modulo: yup.string().required('El modulo es Requerido'),
  estado: fieldStateYupValidation,
});

export const newCuentaSchema = yup.object({
  nombre: yup.string().required('Campo Requerido'),
  codigo: yup.string().required('Campo Requerido').matches(/^[0-9.]+$/, 'Ingresar un codigo valido.'),
  tipo_cuenta_contable: yup.string().optional(),
});
export const newCountryProveedorSchema = yup.object({
  nombre: yup.string().required('Campo Requerido'),
  estado: fieldStateYupValidation,
});
export const newEstadoOrdenCompraSchema = yup.object({
  nombre: yup.string().required('Campo Requerido'),
  codigo: yup.string().required('Campo Requerido'),
});
export const newProyectoSchema = yup.object({
  nombre: yup.string().required('El campo nombre es requerido'),
  codigo: yup.string().required('El codigo es requerido'),
  fecha_inicio: yup.string().required('La fecha de inicio es requerida'),
  fecha_final: yup.string().required('La fecha de finalizacion es requerida'),
  presupuesto: yup
    .number()
    .typeError('El presupuesto es requerido')
    .required('El presupuesto es requerido'),
  descripcion: yup.string().required('La descripcion es requerida'),
  responsable: yup.string().required('El responsable es requerido'),
  descuento: yup
    .number()
    .typeError('El porcentaje de descuento debe ser un número válido')
    .optional()
    .min(0, 'Debe ser mayor al 0%')
    .max(100, 'Debe ser menor a 100%'),
});
export const newTipoFlotaSchema = yup.object({
  nombre: yup.string().required('El nombre de tipo flota es requerida'),
  codigo: yup.string().required('El codigo  de tipo flota es requerida'),
});

export const newTiketUsersSchema = yup.object({
  nombre_requerimento: yup
    .string()
    .required('El nombre requerimiento es requerido'),
  descripcion: yup.string().required('La descripcion es requerida'),
  fecha_creacion: yup
    .string()
    .required('La fecha de realizacion es requerida'),
  departamento: yup.string().required('El departamento es requerido'),
  area: yup.string().required('El area es requerido'),
  empresa: yup.string().required('El area es requerido'),
});

export const newSolicitudesIngresoSchema = yup.object({
  //observacionSolicitante: yup.string().optional(),
  observaciones: yup.object({
    observacionSolicitante: yup.string().required('La observación es requerida'),
  }),
  ubicacion: yup.string().required('La ubicación es requerida'),
  bodega: yup.string().required('La bodega es requerida'),
  codigo: yup.string().optional(),
  email_remitente: yup.string().email().required('La email remitente es requerida'),
  email_receptor: yup.string().email().required('La email receptor es requerida')
});


export const newSolicitudTransferenciaSchema = yup.object({
  referencia: yup.string().required('Campo Requerido'),
  bodega_origen: yup
    .number()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),

  ubicacion_origen: yup
    .number()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),

  bodega_destino: yup
    .number()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  ubicacion_destino: yup
    .string()
    .when('bodega_destino', {
      is: (bodega_destino: number) => bodega_destino != -1,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional()
    .nullable(),
  ubicacion_externa: yup
    .string()
    .when('bodega_destino', {
      is: (bodega_destino: number) => bodega_destino == -1,
      then: schema =>
        schema.required('Campo Obligatorio').typeError('Campo Obligatorio'),
    })
    .optional()
    .nullable(),
  concepto: yup.string().required('Campo Requerido'),
  motivo: yup.string().required('Campo Requerido'),
});



export const newTransferenciaInventarioSchema = yup.object({
  referencia: yup.string().required('Campo Requerido'),
  bodega_origen: yup
    .number()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  bodega_destino: yup
    .number()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  concepto: yup.string().required('Campo Requerido'),
  //motivo: yup.string().optional()
  //fecha_solicitud_transferencia: string;
  //fecha_transferencia: yup.string().required("Campo Requerido"),
});

export const newServicioSchema = yup.object({
  descripcion: yup.string().required('La descripcion es requerida'),
  costo_estandar: yup
    .number()
    .typeError('el costo standar es requerido')
    .required('el costo standar es requerido'),
  iva: yup.string().required('El iva es requerido'),
  categoria: yup.string().required('La categoria del servicio es requerida'),
  proveedor: yup.string().required('El proveedor es requerido'),
});
export const newCategoriaServiciosSchema = yup.object({
  nombre: fieldNameYupValidation,
  descripcion: descriptionYupValidation.required('La descripción es requerida'),
});
export const newUnidadesTransporteSchema = yup.object({
  nombre: yup.string().required('El nombre es requerido'),
  codigo: yup.string().required('El codigo es requerido'),
  placa: yup.string().required('La placa es requerida'),
  chofer_nombre: yup.string().required('El nombre del chofer es requerido'),
  chofer_identificacion: yup
    .string()
    .required('La identificacion del chofer es requerida')
    .test('is-ecuadorian-ci', 'La cédula no es válida', validateEcuadorianCI),
});
//banca clientes
export const newBancaClientesSchema = yup.object({
  codigo: yup.string().required('El codigo es requerido'),
  descripcion: descriptionYupValidation.required('La descripción es requerida'),
  estado: fieldStateYupValidation,
});
export const newComprasSchema = yup.object({
  fecha_emision: yup.string().required('La fecha de emision es requerida'),
  concepto: yup.string().required('El concepto es requerido'),
  observaciones: yup.string().required('La observacion es requerida'),
  numero_autorizacion: yup.string().required('El numero de autorizacion es requerido'),
  ubicacion: yup.string().required('La ubicacion es requerida'),
  //ubicacion:yup.string().optional(),
  proveedor: yup.string().required('El proveedor es requerido'),
  bodega: yup.string().required('La bodega es requerida'),
  //bodega: yup.string().optional()

});
export const newGrupoActivoSchema = yup.object({
  codigo: yup.string().required('El codigo es requerido').max(100, 'El codigo no puede tener más de 100 caracteres'),
  nombre: yup.string().required().max(255, 'El nombre no puede tener más de 255 caracteres'),
  vida_util: yup
    .number()
    .typeError('La vida util es requerida')
    .required('La vida util es requerida').max(7, 'La vida útil no puede ser mayor a 7 años'),
  porcentaje_depreciacion: yup
    .number()
    .typeError('El porcentaje de depreciacion es requerido')
    .required('El porcentaje de depreciacion es requerido').max(100, 'El porcentaje de depreciación no puede ser mayor al 100%'),
  meses_deprecacion: yup
    .number()
    .typeError('Los meses de depreciacion son requeridos')
    .required('Los meses de depreciacion son requeridos'),
  valor_deprecacion_mensual: yup
    .number()
    .typeError('El valor de depreciacion mensual es requerido')
    .required('El valor de depreciacion mensual es requerido'),
  valor_deprecacion_anual: yup
    .number()
    .typeError('El valor de depreciacion anual es requerido')
    .required('El valor de depreciacion anual es requerido'),
  anios_deprecacion: yup
    .number()
    .typeError('Los años de depreciacion son requeridos')
    .required('Los años de depreciacion son requeridos'),
  valor_residual: yup
    .number()
    .typeError('El valor residual es requerido')
    .required('El valor residual es requerido'),
  valor_deprecacion_diaria: yup.number()
    .typeError('El valor de depreciacion diaria es requerido')
    .required('El valor de depreciacion diaria es requerido'),
  estado: fieldStateYupValidation,
});
export const newResponsableSchema = yup.object({
  nombre: yup.string().required('El nombre es requerido'),
  identificacion: yup
    .string()
    .required('La identificacion del chofer es requerida')
    .test('is-ecuadorian-ci', 'La cédula no es válida', validateEcuadorianCI),
  estado: fieldStateYupValidation,
});
export const newAsignacionesSchema = yup.object({
  codigo: yup.string().required('El codigo es requerido'),
  fecha_asignacion: yup.string().required('La fecha asignacion de emision es requerida'),
  fecha_devolucion: yup.string().required('La fecha devolucion es requerida'),
  observaciones: yup.string().required('La observacion es requerida'),
  estado: fieldStateYupValidation,
  empleado: yup.string().required('El empleado es requerido'),
});

export const newMantenimientoSchema = yup.object({
  codigo: yup.string().required('El codigo es requerido'),
  fecha_inicio: yup.string().required('La fecha inicio es requerida'),
  fecha_fin: yup
    .string()
    .required('La fecha fin es requerida'),
  costo: yup.string().required('El costo es requerido'),
  estado: fieldStateYupValidation,
  descripcion: yup.string().required('La descripcion es requerida'),
  encargado: yup.string().required('El encargado es requerido'),
});

export const newActivoSchema = yup.object({
  codigo: yup.string().required('El código es requerido'),
  nombre: yup.string().required('El nombre es requerido'),
  descripcion: yup.string().required('La descripción es requerida'),
  vida_util: yup.number().required('La vida útil es requerida'),
  valor_residual: yup.string().required('El valor residual es requerido'),
  meses_deprecacion: yup.number().required('Los meses de depreciación son requeridos'),
  fecha_adquisicion: yup.string().required('La fecha de adquisición es requerida'),
  costo_adquisicion: yup.string().required('El costo de adquisición es requerido'),
  porcentaje_depreciacion: yup.string().required('El porcentaje de depreciación es requerido'),
  valor_deprecacion_diaria: yup.string().required('El valor de depreciación diaria es requerido'),
  observaciones: yup.string().required('Las observaciones son requeridas'),
  estado: fieldStateYupValidation,
  grupo_activo: yup.string().required('El grupo de activo es requerido'),
});

export const newPeriodoContableSchema = yup.object({
  fecha_inicio: yup.string().required('La fecha es requerida'),
  fecha_fin: yup
    .string()
    .required('La fecha proxima de mantenimiento es requerida'),
});
export const newRadioBaseSchema = yup.object({
  //codigo: yup.string().required('El codigo es requerido'),
  nombre: yup.string().required('El nombre es requerido'),
  direccion: yup.string().required('La direccion es requerida'),
  coordenadas: yup.string().required('Las coordenada es requerida'),
  estado: fieldStateYupValidation,
});
export const newCargosSchema = yup.object({
  codigo: yup.string().required('El codigo es requerido'),
  nombre: yup.string().required('El nombre es requerido'),
  tipo_empleado: yup.string().required('El tipo de empleado es requerido'),
  estado: fieldStateYupValidation,
  empresa: yup.string().required('La empresa es requerida'),
});
export const newGastosSchema = yup.object({
  codigo: yup.string().required('El codigo es requerido'),
  nombre: yup.string().required('El nombre es requerido'),
  descripcion: yup.string().required('La descripcion es requerida'),
  iva: yup.string().required('El IVA es requerido'),
  ice: yup.string().required('El ICE es requerido'),
  costo: yup.string().required('El costo es requerido'),
  proveedor: yup.string().required('El proveedor es requerido'),
  estado: yup.boolean().required('El estado es requerido'),
});
export const newTarjetasSchema = yup.object({
  //codigo: yup.string().required('El codigo es requerido'),
  nombre: yup.string().required('El nombre es requerido'),
  estado: fieldStateYupValidation,
  numero_referencia: yup.string().required('El numero de referencia es requerido'),
});

export const newEgresosSchema = yup.object({
  ///codigo: yup.string().required('El codigo es requerido'),
  fecha: yup.string().required('La fecha es requerida'),
  /* estado: fieldStateYupValidation, */
  bodega: yup.string().required('La bodega es requerida'),
  ubicacion: yup.string().required('La ubicacion es requerida'),
  motivo: yup.string().required('El motivo es requerido'),
  //solicitud_egreso: yup.string().required('La solicitud de egreso es requerida'),
  unidad_transporte: yup.string().required('La unidad de transporte es requerida'),
  observacion_egreso: yup
    .string()
    .test(
      "No se permiten solo espacios en la observacion",
      (value) => {
        if (value === undefined || value == null) return true;
        if (value === "") return true;
        return value.trim().length > 0;
      }
    )
    .transform((value) => {
      if (value === undefined || value === null) return null;
      if (value === "") return null;
      return value.trim();
    })
    .nullable()
});
export const newIventario_ingresoSchema = yup.object({
});
export const newCostoschema = yup.object({
  codigo: yup.string().required('El codigo es requerido'),
  nombre: yup.string().required('El nombre es requerido'),
  descripcion: yup.string().required('La descripcion es requerida'),
  costo: yup.string().required('El costo es requerido'),
  cif: yup.string().required('El CIF es requerido'),
  mano_obra_directa: yup.string().required('La mano de obra directa es requerida'),
  mano_obra_indirecta: yup.string().required('La mano de obra indirecta es requerida'),
  estado: fieldStateYupValidation,
  es_para_venta: yup.boolean().optional(),
  precio_1: yup
    .string()
    .when('es_para_venta', {
      is: true,
      then: schema => schema.required('El precio 1 es requerido'),
    })
    .optional(),
  precio_2: yup
    .string()
    .when('es_para_venta', {
      is: true,
      then: schema => schema.required('El precio 2 es requerido'),
    })
    .optional(),
  precio_3: yup
    .string()
    .when('es_para_venta', {
      is: true,
      then: schema => schema.required('El precio 3 es requerido'),
    })
    .optional(),

});

export const newEmpleadoschema = yup.object({
  tipo_identificacion: yup
    .string()
    .required('El tipo de identificación es Requerido'),
  identificacion: yup.string().required('La identificación es requerida'),
  numero_referencia: yup.string().required('Número de referencia es requerida'),
  razon_social: yup
    .string()
    .when('identificacion', {
      is: 'RUC',
      then: schema =>
        schema
          .required('La razón social es requerida')
          .max(100, 'La longitud máxima es 100 caracteres'),
    }).optional(),
  /* 
  
   */
  direccion: yup.string().required('La dirección es requerida'),
  email: emailYupValidation,
  telefono_1: yup
    .string()
    .required('El teléfono 1 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  telefono_2: yup
    .string()
    .required('El teléfono 2 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  telefono_3: yup
    .string()
    .required('El teléfono 3 es Requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  canal_venta: yup.string().required('El canal de venta es Requerido'),
  tipo_empleado: yup.string().required('El tipo de empleado es Requerido'),
  pais: yup.string().required('El país es Requerido'),
  provincia: yup.string().required('La provincia es requerida'),
  ciudad: yup.string().required('La ciudad es requerida'),
  area: yup.string().required(' El area es requerido'),
  departamento: yup.string().required(' El departamento es requerido'),
  /* cargo:yup.string().required(' El cargo es requerido'), */
  estado: fieldStateYupValidation,
});
export const newPaymentMethodProveedorSchema = yup.object({
  codigo: yup.string().optional(),
  nombre: yup.string().required("El nombre es requerido"),
  tipo_contrato: yup.string().required("El tipo de contrato es requerido"),
  forma_pago: yup.string().required("La forma de pago es requerida"),
  estado: fieldStateYupValidation,
  entidad_financiera: yup.string().required("La entidad financiera es requerida"),
});
export const newRetencionesSchema = yup.object({
  fecha_emision: yup.string().required("La fecha de emisión es requerida"),
  aurorizacion: yup.string().required("La autorización es requerida"),
  concepto: yup.string().required("El concepto es requerido"),
  fecha_ingreso: yup.string().required("La fecha de ingreso es requerida"),
  fecha_caducacion: yup.string().required("La fecha de caducidad es requerida"),
  numero_retencion: yup.string().required("El número de retención es requerido"),
  serie_retencion: yup.string().required("La serie de retención es requerida"),
  base_imponible_iva: yup.string().required("La base imponible de IVA es requerida"),
  base_imponible_ice: yup.string().required("La base imponible de ICE es requerida"),
  base_imponible_ir: yup.string().required("La base imponible de IR es requerida"),
  es_fisica: yup.boolean().required("El tipo de retención es requerido"),
  estado: fieldStateYupValidation,
  asumir_retencion: yup.boolean().required("El tipo de retención es requerido"),
  proveedor: yup.string().required("El proveedor es requerido"),
})

export const newBitacoraComentario = yup.object({
  comentario: yup.string().required("El comentario es obligatorio"),
  username: yup.string().required("Username es requerido"),
  rol: yup.string().required('rol es obligatorio')
})

export const newRecepcionCompraSchema = yup.object({
  ubicacion: yup.string().required('La ubicacion es requerida'),
  bodega: yup.string().required('La bodega es requerida'),
  //numero_factura: yup.string().required('El N° de factura es Obligatorio'),
  numero_factura: yup.string().optional(),
  numero_guia_remision: yup.string().optional(),
});
export const newUpdateOrdenCompraSchema = yup.object({
  observaciones: yup.object({
    observacionCerrarOrden: yup.string().required("La observación es obligatoria")
  })
})
export const newRegistroFactura = yup.object({

  fecha_emision: yup.string().required('La fecha de emision es requerida'),
  concepto: yup.string().required('El concepto es requerido'),
  numero_autorizacion: yup.string().required('El numero de autorizacion es requerido'),
  proveedor: yup.string().required('El proveedor es requerido'),
  tipo_comprobante: yup.string().required('El tipo de contrato es requerido'),
  forma_pago: yup.string().required('La forma pago es obligatorio'),
  fecha_vencimiento: yup.string().required('La fecha vencimiento es obligatorio')

})
